import type { UseQueryResult } from "@tanstack/react-query"
import { useQuery } from "@tanstack/react-query"

import { USER_KEYS } from "~/api/cache"

type CurrentUser = {
  permissions: string[]
}

export function useCurrentUser(): UseQueryResult<CurrentUser> {
  return useQuery({
    queryKey: USER_KEYS.profile(),
    queryFn: () => {
      throw new Error(
        `useCurrentUser has no queryFn — data is seeded by useAuth`,
      )
    },
    enabled: false,
  })
}

export function useDoesCurrentUserHavePermissions(
  required: readonly string[],
): boolean {
  const { data } = useCurrentUser()
  const permissions = data?.permissions ?? []

  return required.some((permission) => permissions.includes(permission))
}
